import { render } from "./Address.vue?vue&type=template&id=ec954196"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pekancar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__